import { render } from "./NewView.vue?vue&type=template&id=05c55b80&ts=true"
import script from "./NewView.vue?vue&type=script&lang=ts"
export * from "./NewView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__